import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppContext } from '@datapad/data-model';
import { useWidth } from '@datapad/theming';
import { useTree } from '@fluidframework/react/alpha';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import { ProfileHeader } from './ProfileHeader.js';
import { ProfileImage } from './ProfileImage.js';
import { AdminTab, BiographyTab, OverviewTab, RelationshipsTab, TabPanel } from './tabs/index.js';
var ProfileTab;
(function (ProfileTab) {
    ProfileTab["Overview"] = "overview";
    ProfileTab["Biography"] = "biography";
    ProfileTab["Relationships"] = "relationships";
    ProfileTab["Admin"] = "admin";
})(ProfileTab || (ProfileTab = {}));
export function CharacterProfile(props) {
    const { character, canEdit } = props;
    useTree(character);
    const appContext = useAppContext();
    const isGameMaster = appContext.getEffectivePermissionLevel() === 'game-master';
    const currentDate = appContext.permissionLevel !== 'guest' &&
        'campaign' in appContext &&
        appContext.campaign !== undefined
        ? appContext.getCampaign(appContext.campaign).currentDate
        : undefined;
    const [activeTab, setActiveTab] = React.useState(ProfileTab.Overview);
    React.useEffect(() => {
        if (activeTab === ProfileTab.Admin && !isGameMaster) {
            setActiveTab(ProfileTab.Overview);
        }
    }, [activeTab, isGameMaster]);
    const width = useWidth();
    const isNarrowView = width === 'xs' || width === 'sm';
    const tabs = [
        {
            id: ProfileTab.Overview,
            label: 'Overview',
            content: (_jsx(OverviewTab, { character: character, currentDate: currentDate, canEdit: canEdit })),
        },
        {
            id: ProfileTab.Biography,
            label: 'Biography',
            content: _jsx(BiographyTab, { character: character, canEdit: canEdit }),
        },
        {
            id: ProfileTab.Relationships,
            label: 'Relationships',
            content: _jsx(RelationshipsTab, { character: character, canEdit: canEdit }),
        },
    ];
    if (isGameMaster) {
        tabs.push({
            id: ProfileTab.Admin,
            label: 'Admin',
            content: _jsx(AdminTab, { character: character, canEdit: canEdit }),
        });
    }
    const handleTabChange = (_event, newValue) => {
        setActiveTab(newValue);
    };
    return (_jsxs(Box, { sx: { height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }, children: [_jsxs(Box, { sx: { flexShrink: 0, p: 2 }, children: [_jsx(ProfileHeader, { character: character, canEdit: canEdit }), _jsx(Box, { sx: { display: 'flex', justifyContent: 'center', mt: 2 }, children: _jsx(ProfileImage, { character: character, canEdit: canEdit }) })] }), _jsxs(Box, { sx: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }, children: [_jsx(Tabs, { value: activeTab, onChange: handleTabChange, variant: isNarrowView ? 'scrollable' : 'standard', scrollButtons: isNarrowView ? 'auto' : false, centered: !isNarrowView, "aria-label": "Character profile tabs", children: tabs.map((tab) => (_jsx(Tab, { value: tab.id, label: tab.label, id: `profile-tab-${tab.id}`, "aria-controls": `profile-tabpanel-${tab.id}` }, tab.id))) }), _jsx(Box, { sx: { flex: 1, minHeight: 0, overflow: 'hidden' }, children: tabs.map((tab) => (_jsx(TabPanel, { value: activeTab, index: tab.id, id: "profile", children: tab.content }, tab.id))) })] })] }));
}
//# sourceMappingURL=CharacterProfile.js.map